import React, {useEffect, useState} from 'react'
import {Button, MenuItem, Stack, TextField} from '@mui/material'
import {useTranslation} from 'react-i18next'
import DashboardCard from '@containers/dashboard/ui/DashboardCard'
import {useApplyDashboardSettingsMutation} from '@containers/dashboard/queryHooks/useDashboardQuery'
import {IDashboardInfo} from '@containers/dashboard/types'
import {useAccountStyle} from '@containers/accountStyle/hooks/useAccountStyle'
import ZoneClock from '@containers/dashboard/settings/ZoneClock'

interface IProps {
	info?: IDashboardInfo
}

const SettingsCard = ({info}: IProps) => {
	const {t} = useTranslation()
	const {tokens} = useAccountStyle()
	const {mutate, isPending} = useApplyDashboardSettingsMutation()

	const [timeZone, setTimeZone] = useState('')
	const [startPage, setStartPage] = useState('')

	useEffect(() => {
		if (!info) return
		setTimeZone(info.timeZone ?? '')
		setStartPage(info.startPage ?? '')
	}, [info])

	const onSave = () => {
		mutate({
			timeZone: timeZone || undefined,
			startPage: info?.editForm ? startPage || undefined : undefined,
		})
	}

	return (
		<DashboardCard title={t('dashboardPage.settings')}>
			<Stack gap={1.5}>
				<ZoneClock timeZone={info?.timeZones.find((item) => item.value === timeZone)?.label}/>

				<TextField
					select
					size={'small'}
					label={t('dashboardPage.timeZone')}
					value={timeZone}
					onChange={(e) => setTimeZone(e.target.value)}
					disabled={!info}
				>
					{(info?.timeZones ?? []).map((item) => (
						<MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
					))}
				</TextField>

				{info?.editForm && <TextField
					select
					size={'small'}
					label={t('dashboardPage.startPage')}
					value={startPage}
					onChange={(e) => setStartPage(e.target.value)}
				>
					{info.startPages.map((item) => (
						<MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
					))}
				</TextField>}

				<Button
					variant={'contained'}
					onClick={onSave}
					disabled={!info || isPending}
					sx={{bgcolor: tokens.accent, '&:hover': {bgcolor: tokens.accent, filter: 'brightness(.9)'}}}
				>
					{t('dashboardPage.save')}
				</Button>
			</Stack>
		</DashboardCard>
	)
}

export default SettingsCard
